// 🔥 CORRIGIDO — FONTE ÚNICA DO DISCLAIMER LEGAL: antes esse texto estava
// copiado à mão em 4 lugares diferentes (MobileInterface.jsx duas vezes,
// GestorDashboardInterface.jsx, ReportEngine.jsx) e cada cópia foi divergindo
// aos poucos com o tempo — quem lê o relatório no app via um texto e quem
// baixa o PDF via outro, ligeiramente diferente. Agora existe só esta
// constante; qualquer alteração de redação (ex: nova ressalva jurídica) é
// feita AQUI UMA VEZ SÓ e reflete em toda superfície automaticamente.
export const DISCLAIMER_FULL = "NOTIFICAÇÃO DE RESPONSABILIDADE E CONFORMIDADE TÉCNICA: Parecer Técnico Estratégico desenvolvido por sistema de inteligência artificial de alta performance (Phoenix OS®). As conclusões baseiam-se na integridade dos dados fornecidos pelo usuário. RESSALVAS: 1) Não constitui auditoria estatutária oficial (CVM/BACEN); 2) Documento de uso interno da administração, estritamente confidencial e protegido por propriedade intelectual; 3) Os limiares de referência (alavancagem, margem) usados na classificação de risco por setor são estimativas de benchmark de mercado, sujeitas a variação conforme fatores específicos da operação (garantias, prazos, sazonalidade, condições macroeconômicas e outros agentes externos) — não substituem a análise de um profissional habilitado.";

export const FAQ_DATA = [
    { q: "O que é o Phoenix OS?", a: "É um software de inteligência executiva que funciona como um conselho de administração digital." },
    { q: "Meus dados financeiros estão seguros?", a: "Absolutamente. Seus dados são processados em ambiente isolado utilizando criptografia AES-256." },
    { q: "Qual a diferença entre os perfis?", a: "O Perfil Iniciante traduz finanças para linguagem prática. O Profissional usa jargões de mercado (IFRS, WACC)." },
    { q: "O que é o Módulo Apex?", a: "É o nosso motor de Valuation (DCF) que calcula o valor de mercado da sua empresa." }
];

export const DISCLAIMER_TEXT = "NOTIFICAÇÃO DE RESPONSABILIDADE E CONFORMIDADE TÉCNICA: Este Parecer Técnico Estratégico foi desenvolvido mediante processamento por IA...";

// ===================================================================
// 🏢 SOBRE / DADOS DA EMPRESA — fonte única de verdade, usada no App e
// nos dois Dashboards (Gestor e Consultor), pra não ter que editar o
// mesmo dado em 3 lugares. Hoje está com placeholders porque a empresa
// ainda não foi formalizada — assim que tiver CNPJ, razão social e
// contato de suporte definidos, é só preencher AQUI e atualiza nos 3
// lugares de uma vez.
//
// ⚠️ IMPORTANTE: os links de Política de Privacidade e Termos de Uso
// abaixo são placeholders ('#'). Esse é conteúdo jurídico — recomendo
// que um advogado redija os textos reais antes do lançamento comercial,
// principalmente por lidar com dados financeiros sensíveis de terceiros
// (LGPD). Não gerei texto jurídico aqui de propósito.
// ===================================================================
export const COMPANY_INFO = {
    nomeFantasia: 'Phoenix OS',
    // 🔥 NOVO: "Phoenix OS" é o PRODUTO; "Vantum Tecnologia" é o nome
    // público da empresa que opera o produto (a razão social,
    // "Samuel Benevides do Nascimento LTDA", é o nome pessoal que não deu
    // tempo de trocar no Contabilizei — nunca deve ser a única identidade
    // visível pro cliente). Já estava certo nos Termos de Uso/Política de
    // Privacidade (LegalPages.jsx), mas faltava aparecer na tela "Sobre"
    // dentro do próprio app — o Samuel notou a ausência.
    nomeEmpresa: 'Vantum Tecnologia',
    razaoSocial: 'Samuel Benevides do Nascimento LTDA',
    cnpj: '69.171.174/0001-13',
    emailSuporte: 'suporte@phoenixos.com.br',
    telefoneSuporte: '',
    endereco: 'R. Visconde do Rio Branco, 1488 - Centro, Curitiba - PR',
    versaoApp: '1.0.0',
    anoFundacao: '2026',
    linkPoliticaPrivacidade: '/politica-de-privacidade',
    linkTermosDeUso: '/termos-de-uso',
    descricaoCurta: 'Inteligência executiva para micro, pequenas empresas e escritórios de consultoria — diagnóstico financeiro, CFO Virtual e M&A Readiness num só lugar.',
};